import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, EXPORT_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async GetPendingJobsSafetyRemarksListReport(OrderFromDate: any, OrderToDate: any, OrganizationIds:Number[], languageId:any, ColumnSequence: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${API_NAME}/GetPendingJobsSafetyRemarksListReport?orderFromDate=${OrderFromDate}
			&orderToDate=${OrderToDate}&OrganizationIds=${OrganizationIds}&ColumnSequence=${ColumnSequence}&LanguageId=${languageId}`, EXPORT_FILE_NAME);
	}
}

export const apiProvider = new SestavyApi();
